import React, { useEffect, useState } from "react";
import PageMenu from "../components/PageMenu";
import { Card, Col, Row } from "react-bootstrap";
import BasicLineChart from "../../../../../../components/chart/BasicLineChart";
import BasicColumnChart from "../../../../../../components/chart/BasicColumnChart";
import ReactTable from "../../../../../../lib/table/react-table";
import {
  transformExposureData,
  transformUniqueUsersData,
} from "../../utils/commonFunctions";
import {
  useGetProjectDetails,
  useGetSummaryCount,
  useGetSummaryEngagedBrandExposure,
  useGetSummaryEngagedUniqueUsers,
  useGetSummaryEngagedUserList,
} from "../../../../../../queries/query-hooks/workspace/emsl-hook";
import { useParams } from "react-router-dom";
import BarChartSkeleton from "../../../../../../skeleton/workspace/clirnet/brand-ads/bar-chart-skeleton";
import CommonTableLoader from "../../../../../../skeleton/common-table-loader";
import { ProjectHeaderTopBar, TableHeader, CardNotFound } from "@ui";
import useCsvDownloader from "components/custom-hooks/use-csv-downloader";

const EngagedHCP = () => {
  const { project_id } = useParams();
  const { downloadCSV } = useCsvDownloader();
  const { data: projectDetails, isLoading: isProjectDetailsLoading } =
    useGetProjectDetails(project_id, true);
  const [tableOffset, setTableOffset] = useState(0);
  const [currentPageNumber, setCurrentPageNumber] = useState(0);

  const contentIds = projectDetails?.content
    ?.map((item) => item?.content_id)
    .join(",");

  const { data: summaryCount, isLoading: isSummaryCountLoading } =
    useGetSummaryCount(project_id, {
      start_date: projectDetails?.project_start_date,
      end_date: projectDetails?.project_end_date,
      content_id: contentIds,
    });

  const payload = {
    start_date: projectDetails?.project_start_date,
    end_date: projectDetails?.project_end_date,
    content_id: contentIds,
  };
  const tablePayload = {
    start_date: projectDetails?.project_start_date,
    end_date: projectDetails?.project_end_date,
    content_id: contentIds,
    masked_data: true,
    offset: tableOffset,
    limit: summaryCount?.enagaged_hcps,
  };
  const [maskedType, setMaskedType] = useState(true);
  const { data: brandExposure, isLoading: isBrandExposureLoading } =
    useGetSummaryEngagedBrandExposure(project_id, payload);
  const { data: uniqueUsers, isLoading: isUniqueUsersLoading } =
    useGetSummaryEngagedUniqueUsers(project_id, payload);
  const { data: usersList, isLoading: isUsersListLoading } =
    useGetSummaryEngagedUserList(project_id, tablePayload);

  const totalCount = usersList?.totalCount;

  const { data: unMaskedUsersList, isLoading: isUnMaskedUsersListLoading } =
    useGetSummaryEngagedUserList(project_id, {
      ...tablePayload,
      offset: 0,
      limit: summaryCount?.enagaged_hcps,
      masked_data: maskedType,
    });

  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    if (!isUnMaskedUsersListLoading && maskedType === false) {
      downloadCSV(hcpTableCsvFormat);
      setMaskedType(true);
    }
  }, [unMaskedUsersList, isUnMaskedUsersListLoading]);

  const filteredUsers = usersList?.rows?.filter(
    (user) =>
      user?.location
        ?.toLowerCase()
        .includes(searchText?.toLowerCase()?.trim()) ||
      user?.registration_body
        ?.toLowerCase()
        .includes(searchText?.toLowerCase()?.trim()) ||
      user?.ip_address
        ?.toLowerCase()
        .includes(searchText?.toLowerCase()?.trim())
  );

  const hcpTableCsvFormat = {
    header: [
      "Name",
      "Specialty",
      "Location",
      "Registration No.",
      "Registration Body",
      "IP Address",
    ],
    column: [
      "name",
      "speciality",
      "location",
      "registration_no",
      "registration_body",
      "ip_address",
    ],
    rows: unMaskedUsersList?.rows,
  };

  const LOCATION_REPORT_TABLE_COLUMNS = [
    {
      columnId: 1,
      Header: "Name",
      accessor: "name",
      disableFilters: true,
      Cell: (value) => {
        if (!value.value) return "---";
        return value.value;
      },
    },
    {
      columnId: 2,
      Header: "specialty",
      accessor: "speciality",
      disableFilters: true,
      Cell: (value) => {
        if (!value.value) return "---";
        return value.value;
      },
    },
    {
      columnId: 3,
      Header: "Location",
      accessor: "location",
      disableFilters: true,
      Cell: (value) => {
        if (!value.value) return "---";
        return value.value;
      },
    },
    {
      columnId: 4,
      Header: "Registration No.",
      accessor: "registration_no",
      disableFilters: true,
      Cell: (value) => {
        if (!value.value) return "---";
        return value.value;
      },
    },
    {
      columnId: 5,
      Header: "Registration Body",
      accessor: "registration_body",
      disableFilters: true,
      Cell: (value) => {
        if (!value.value) return "---";
        return value.value;
      },
    },
    {
      columnId: 6,
      Header: "IP Address",
      accessor: "ip_address",
      disableFilters: true,
      disableSortBy: true,
      Cell: (value) => {
        if (!value.value) return "---";
        return value.value;
      },
    },
  ];

  const formattedBrandExposureData = transformExposureData(
    brandExposure,
    "Brand Exposure",
    "#1aa053"
  );

  const formattedUniqueUsersData = transformUniqueUsersData(
    uniqueUsers,
    "Unique Users Cumulative",
    "#3256b8"
  );

  const onTableStateChange = (e) => {
    setCurrentPageNumber(e?.pageIndex);
    setTableOffset(e?.pageIndex * 10);
  };

  const exportCSV = () => {
    setMaskedType(false);
  };

  return (
    <div className="mb-3">
      <ProjectHeaderTopBar
        projectType="eMSL"
        title="Engaged HCP's"
        projectStartDate={projectDetails?.project_start_date || ""}
        projectEndDate={projectDetails?.project_end_date || ""}
        status={projectDetails?.status}
        isProjectDetailsLoading={isProjectDetailsLoading}
      />
      <PageMenu name="enagaged_hcps" />

      <Row>
        <Col md={6} sm={12}>
          {!isBrandExposureLoading && brandExposure?.length > 0 ? (
            <BasicLineChart
              title={"Brand Exposure"}
              tooltip="Total number of times your brand was viewed by HCP's during the campaign"
              labels={formattedBrandExposureData.labels}
              series={formattedBrandExposureData.series}
            />
          ) : isBrandExposureLoading ? (
            <BarChartSkeleton />
          ) : (
            <CardNotFound
              title={"Brand Exposure"}
              height={360}
              tooltip="Total number of times your brand was viewed by HCP's during the campaign"
            />
          )}
        </Col>
        <Col md={6} sm={12}>
          {!isUniqueUsersLoading && uniqueUsers?.length > 0 ? (
            <BasicColumnChart
              title={"Unique Users"}
              tooltip="Total distinct users who engaged with your campaign over the selected period"
              labels={formattedUniqueUsersData.labels}
              series={formattedUniqueUsersData.series}
              dataLabelsShow={false}
            />
          ) : isUniqueUsersLoading ? (
            <BarChartSkeleton />
          ) : (
            <CardNotFound
              title={"Unique Users"}
              height={360}
              tooltip="Total distinct users who engaged with your campaign over the selected period"
            />
          )}
        </Col>
      </Row>

      <Row>
        <Col sm={12}>
          <Card>
            <TableHeader
              title="Users List"
              searchProps={{
                isNeeded: true,
                placeholder:
                  "Search via Location / Registration Body / IP Address",
                searchText: searchText,
                setSearchText: setSearchText,
              }}
              downloadProps={{
                needCsvDownload: true,
                exportCSVHandler: exportCSV,
              }}
            />
            <Card.Body>
              {!isUsersListLoading ? (
                <ReactTable
                  data={Array.isArray(filteredUsers) ? filteredUsers : []}
                  columns={LOCATION_REPORT_TABLE_COLUMNS}
                  recordsTotal={totalCount}
                  isPaginationShow={false}
                  currentPageNumber={currentPageNumber}
                  bordered
                  contentCenter
                  noDataText="No Data Available"
                  onTableStateChange={onTableStateChange}
                />
              ) : (
                <CommonTableLoader
                  tableRowLength={5}
                  hasSearch={false}
                  hasActions={false}
                />
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default EngagedHCP;
